import ky from "ky";
import { config } from "@/config";

export const apiClient = ky.create({
  prefix: `https://${config.apiHost}`,
  timeout: 15000,
  retry: {
    limit: 3,
    methods: ["GET", "PUT", "HEAD", "DELETE", "OPTIONS", "TRACE"],
    statusCodes: [408, 413, 429, 500, 502, 503, 504],
    backoffLimit: 5000,
    delay: (attemptCount) => {
      const delays = [1000, 2000, 4000];
      return delays[Math.min(attemptCount - 1, delays.length - 1)];
    },
  },
  headers: {
    "Content-Type": "application/json",
  },
});

export function createApiClient(options?: {
  authToken?: string;
  apiVersion?: string;
}) {
  const { authToken, apiVersion = "v3" } = options || {};

  const headers: Record<string, string> = {
    "Content-Type": "application/json",
  };

  if (authToken) {
    headers["Authorization"] = `Bearer ${authToken}`;
  }

  return apiClient.extend({
    headers,
    prefix: `https://${config.apiHost}/${apiVersion}`,
  });
}

export const DEFAULT_CLIENT_TEMPLATE = {
  language_code: "eng",
  receipt_template_id: "default",
};

export const DEFAULT_RECEIPT_SERVICES: string[] = [];
